export const sizeOptionClassification = {
  is_multiselect: false,
  is_mandatory: true,
  sequenceNumber: 0,
  selectedoptions: [],
  optionsCount: 1,
  hiddenInFrontend: false,
  hiddenInPdf: false,
  creatorView: null,
  identifier: 'size',
  title: 'size',
  description: '',
  attributes: [],
  thumbnail: '/images/components/size.png',
  minimumOrderAmount: null,
};
